import {NgxPermissionsService} from 'ngx-permissions';
import {UserVO} from './../model/UserVO';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AuthService} from './AuthService';
import {Injectable, Injector} from '@angular/core';
import {environment} from '../../environments/environment';
import 'rxjs/add/operator/filter';
import * as moment from 'moment';
import {APP_BASE_HREF} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {FeatureAccessService} from './feature-access.service';

const COMPANY_OMIEN : any[] = ['OMI','AJ3','COS'];


@Injectable()
export class UserService {

  private href: string = '';
  private uservo: UserVO = null;
  constructor(private authService: AuthService,private featureAccessService: FeatureAccessService, private injector: Injector, private permissionsService: NgxPermissionsService, private http: HttpClient) {
    if (localStorage.expires_in) {
      const expires_date = new Date(parseInt(atob(localStorage.expires_in)));
      const expires_valide = moment().isAfter(moment(expires_date));
      if ( expires_valide ) {
        localStorage.clear();
        window.location.reload();
      }
    }
  }

  public get activatedRoute(): ActivatedRoute {
    return this.injector.get(ActivatedRoute);
  }

  public get router(): Router {
    return this.injector.get(Router);
  }

  load() {
    // console.log();
    if (!localStorage.getItem(environment.oauth.remoteUser)) {
      this.router.events.filter(e => e instanceof NavigationEnd && !this.authService.getFromSession(environment.oauth.remoteUser))
        .forEach(e => {
          this.activatedRoute.paramMap.subscribe();
          const callbackUrl = environment.oauth.redirectTo;
          let secret = '';
          const secretFromSession = this.authService.getFromSession(environment.oauth.state);
          if (this.activatedRoute.snapshot.queryParamMap.has('code')) {
            const code = this.activatedRoute.snapshot.queryParamMap.get('code');
            this.authService.saveInSession(environment.oauth.code, code);
            //// console.log(code);
            secret = this.activatedRoute.snapshot.queryParamMap.get('state');
            if (secret === secretFromSession) {
              this.authService.getAccessToken(code).subscribe(user => {
                this.uservo = user;
                this.setPermission(this.getPermissionAuthorities(this.uservo, environment.clients, 'ROLE_NOT_ALLOWED'));
            //   location.assign(location.origin + '/#/');
                window.history.replaceState(null, null, window.location.pathname);
              }, error => {
                // console.log(error);
              });
            }
          } else {
            secret = 'secret' + this.authService.randomInt(0, 999999);
            this.authService.saveInSession(environment.oauth.state, secret);
            const authorizationUrl = this.authService.getAuthorizationUrl(secret, callbackUrl);
          }
        });
    }
    this.uservo = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    if (this.uservo !== null) {
      this.setPermission(this.getPermissionAuthorities(this.uservo, environment.clients, 'ROLE_NOT_ALLOWED'));
    }
  }

  public setPermission(array) {
    if(!localStorage.getItem("ROLE") || localStorage.getItem("ROLE") == 'null')
      this.permissionsService.loadPermissions(array);
    else if (localStorage.getItem("ROLE") == "ROLE_DEFAULT_MYSHIFT"){
      this.permissionsService.loadPermissions(array);
    }else {
      let permissions = localStorage.getItem("ROLE").split(",");
      this.permissionsService.loadPermissions(permissions);
    }

  }

  public getHRBPOrDirectorManagers(registrationNumber,isHRProtugal){
    return isHRProtugal? this.getHRBP(registrationNumber):this.directorManagers(registrationNumber);
  }
  public getHRBP(registrationNumber){
    // return this.http.get(`${environment.api.mscore}city-time-zone/${ville}/${date}`);
    return this.http.get(environment.api.mscore + 'management/rh/' + registrationNumber);
  }
  public directorManagers(registrationNumber) {
    return this.http.get(`${environment.api.mscore}management/dirsite/${registrationNumber}`);
  }

  public getPermission() {
    return this.permissionsService.getPermissions();
  }

  randomInt(min, max): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public getUser(key?: string) {
    const user = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    if ( typeof key === 'undefined') {
      return user;
    } else {
      return user[key];
    }
  }

  public getUserCountry() {
    return this.getUser().countryCode;
  }

  public checkIfCountryAuthorizedForUnlocking(isFromSidebar) {
    const country = this.getUserCountry();
    if (!isFromSidebar)
      return country ? this.featureAccessService.hasAccess('UNLOCKING',country.toUpperCase()): false;

    let permissions = this.getPermission();
    let hasRoleDelegation = permissions.DEVEROUILLAGE;
    return country ? this.featureAccessService.hasAccess('UNLOCKING',country.toUpperCase()) || hasRoleDelegation: false;
  }

  public getCurrentUser(key?: string) {
    const user = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    return user[key];
  }

  public getPermissionAuthorities(user: any, keys: string[], except?: string) {
    let permissions: Array<string> = [];
    user.authorities.reduce((i, n, index, array ) => {
      if (keys.indexOf(n.clientId) > -1) permissions.push(n.authority);
    }, {});
    return (permissions.length > 0 ? permissions : [except]);
  }
  isHorsProdMyShift() {
    let detailsUser = JSON.parse(localStorage.getItem("DETAILS"));
    return detailsUser && detailsUser.job && detailsUser.job.name? FeatureAccessService.hasAccess('REPORTING',detailsUser.job.name.toUpperCase()): false;
  }

  checkIfUserFromTheOMICompany() {
    let detailsUser = JSON.parse(localStorage.getItem("DETAILS"));
    return detailsUser && COMPANY_OMIEN.includes(detailsUser.company);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/UserService.ts